import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Headers, Http, RequestOptions} from '@angular/http';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class AlgorithmConfigService {
  readonly baseURL = DDP_ENV.campaignUrl;

  constructor(private _http: Http, private cookieService: CookieService) { }

  getAllSystemAlgorithm() {
    console.log('Inside Get All System Algorithms');
    return this._http.get(this.baseURL + '/algorithm-config/campaign/SYSTEM', this.buildHeaders());
  }

  search(regex, page, size) {
    return this._http.get(this.baseURL + '/campaign/?page=' + page + '&size=' + size + '&regexPattern=' + regex, this.buildHeaders());
  }

  getAllCampaignAlgorithm(campaignId) {
    console.log('Inside Get All Campaign Algorithms');
    return this._http.get(this.baseURL + '/algorithm-config/campaign/' + campaignId, this.buildHeaders());
  }

  getAllAlgos() {
    console.log('Inside Get All System Filters');
    return this._http.get(this.baseURL + '/algorithm-config/type', this.buildHeaders());
  }

  getAlgoById(algoId) {
    console.log('Inside Get by  Filter Id');
    return this._http.get(this.baseURL + '/algorithm-config/' + algoId, this.buildHeaders());
  }

  updateAlgo(algo) {
    console.log('Inside Update All System Algo');
    return this._http.put(this.baseURL + '/algorithm-config/' + algo.id , algo, this.buildHeaders());
  }

  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }
}
